import React from 'react';

const GallerySection = ({ translations = {} }) => {
  const images = [
    '/images/galeria1.webp',
    '/images/galeria2.png',
    '/images/galeria3.webp',
    '/images/galeria4.webp',
    '/images/galeria5.png',
  ];

  return (
    <section className="py-20 bg-[#FFF8F0] text-gray-800">
      <div className="container mx-auto px-4 text-center">
        <h2 className="text-4xl font-bold text-[#FF4C29] mb-12 animate-fade-in">
          {translations.galleryTitle || 'Gallery'}
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {images.map((src, index) => (
            <div key={index} className="overflow-hidden rounded-2xl shadow-xl animate-zoom-in-delay" style={{ animationDelay: `${index * 0.1}s` }}>
              <img
                src={src}
                alt={`Gallery Image ${index + 1}`}
                className="w-full h-64 object-cover transform hover:scale-110 transition-transform duration-300 ease-in-out"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default GallerySection;